import React from "react";
import NextImage from "@components/Image/NextImage";
import { findSiteName, getEnvPrefix } from "helpers/Helper";
import Sites from "src/constants/Sites";
import styles from "./PostSearch.module.css";
import "./PostSearch.css";

const PostSearch = (props) => {
  let {
    posts,
    name,
    siteId,
    renderSubtitle = false,
    showTopImage = true,
  } = props;

  let topPostIndex;
  let topPost =
    posts &&
    posts.filter((post, i) => {
      if (post?.topStory) {
        topPostIndex = i;
        return true;
      }
    });
  if (!topPost || (topPost && topPost.length < 1)) {
    topPost = posts && posts[0];
    topPostIndex = 0;
  } else {
    topPost = topPost[0];
  }

  posts.splice(topPostIndex, 1);
  posts.splice(0, 0, topPost);

  const buildPostLink = (post, site) => {
    let url;
    let prefix = getEnvPrefix();
    let siteName = findSiteName(site);
    url = prefix + siteName + "/" + post?.slug?.[0];
    return url;
  };
  const renderListItem = (post) => {
    return (
      <>
        <div className="item-pretitle">{post?.tags?.[0]?.name}</div>
        {siteId !== Sites.EARLYBIRDBOOKS ? (
          <a
            href={buildPostLink(post, siteId)}
            target="_blank"
            rel="noopener"
            className="item-title"
          >
            <span dangerouslySetInnerHTML={{ __html: post?.title }}></span>
          </a>
        ) : (
          <a href={post?.slug?.[0]} className="item-title">
            <span dangerouslySetInnerHTML={{ __html: post?.title }}></span>
          </a>
        )}
        <div
          className={[styles["item-subtitle"], renderSubtitle ? styles["item-render-subtitle"] : "", "item-subtitle"].join(" ")}
          dangerouslySetInnerHTML={{ __html: post?.sub_title }}
        ></div>
      </>
    );
  };
  return (
    <>
      <div className={`post-search section-${name}`}>
        {showTopImage && (
          <div className={[styles["section-image"], "section-image"].join(" ")}>
            <a href={`/${topPost?.slug[0]}`}>
              <NextImage
                {...topPost?.featured_media}
                isLazyLoading={false}
                isFeaturedImage={true}
                width={331}
                height={139}
                style={{width: '100%', height: '100%'}}
              />
            </a>
          </div>
        )}
        <ul className={[styles["section-items"], "section-items"].join(" ")}>
          {posts &&
            posts.length > 0 &&
            posts.map((post) => (
              <li key={post.id} className={styles["list-item"]}>
                {renderListItem(post)}
              </li>
            ))}
        </ul>
      </div>
    </>
  );
};

export default PostSearch;
